import Page from '@/found/components/table_page/table_page.vue';
import Form from './form';

export default {
  extends: Page,
  data() {
    return {
      formConfig: {},
      configs: {
        formConfig: {},
      },
      modalConfig: {},
    };
  },
  components: { Form },
  created() {
    this.getConfigList('main_list');
  },
  methods: {
    /**
     * 列表点击事件
     * @param {object} val 点击对象绑定数据
     * @param {object} row 点击列表行数据
    */
    clickVisible({ row, val: { code } }) {
      if (row.orderStatus === '3') {
        return true;
      }
      return false;
    },
    modalClick({
      val,
      row,
    }) {
      const {
        code,
        name,
      } = val;
      this.formName = 'Form';
      console.log(code);
      if (code === 'view') {
        this.modalConfig.title = name;
        this.formConfig = {
          code,
          row,
        };
        this.openFull();
      }
      if (code === 'addLogisticsNumber') {
        this.modalConfig.title = name;
        this.formConfig = {
          code: 'view',
          row,
        };
        this.openFull();
      }
    },
  },
};
